import { Box } from '@customink/pigment-react';
import type { ProjectItem } from '@customink/project-service-react-components';
import {
  hasView,
  useProduct,
} from '@customink/project-service-react-components';

import ProofImage from '../ProofImage';

type ProjectItemProofProps = {
  item: ProjectItem;
  displayDraft?: boolean;
};
export const ProjectItemProof = ({
  item,
  displayDraft = false,
}: ProjectItemProofProps) => {
  const { data: product } = useProduct({
    colorId: item.product?.colorId,
  });

  const thumbnailView = hasView('back', product?.views)
    ? 'back_medium_extended.png'
    : undefined;

  return (
    <Box borderRadius="8px" overflow="hidden">
      <ProofImage
        cid={item.design?.cid}
        colorId={item.product?.colorId}
        draft={displayDraft}
        isProjectItemProof={true}
        thumbnailView={thumbnailView}
        view="front_medium_extended.png"
        withLegacyOptions
      />
    </Box>
  );
};
